import ReservationVol from './ReservationVol';
export default ReservationVol;
